import React from "react";
export const doctorMenuList = [
  {
    lightIcon: <LightHomeIcon />,
    solidIcon: <SolidHomeIcon />,
    itemName: "Overview",
    itemLink: "/dashboard",
    solidIncludesCheck: ""
  },
  {
    lightIcon: <LightAppointmentIcon />,
    solidIcon: <SolidAppointmentIcon />,
    itemName: "Appointments",
    itemLink: "/dashboard/appointments/summary",
    solidIncludesCheck: "appointments"
  },
  {
    lightIcon: <LightPCIIcon />,
    solidIcon: <SolidPCIIcon />,
    itemName: "PCI",
    itemLink: "/dashboard/pci",
    solidIncludesCheck: "pci"
  },
  {
    lightIcon: <LightReviewIcon />,
    solidIcon: <SolidReviewIcon />,
    itemName: "Reviews",
    itemLink: "/dashboard/reviews",
    solidIncludesCheck: "reviews"
  },
  {
    lightIcon: <LightAppointmentIcon />,
    solidIcon: <SolidAppointmentIcon />,
    itemName: "Pending",
    itemLink: "/dashboard/pendingAppointments",
    solidIncludesCheck: "pendingAppointments"
  },
  {
    lightIcon: <LightAuditLogsIcon />,
    solidIcon: <SolidAuditLogsIcon />,
    itemName: "Audit Logs",
    itemLink: "/dashboard/auditLogs",
    solidIncludesCheck: "auditLogs"
  }
];

export const buttonList = [
  {
    buttonIcon: <CheckoutIcon />,
    buttonText: "Checkout",
    primaryColor: "#22548A",
    secondaryColor: "rgba(34, 84, 138, 0.1)",
    onClickFunctionName: "checkout"
  },
  {
    buttonIcon: <LogoutIcon />,
    buttonText: "Logout",
    primaryColor: "rgba(232, 102, 105, 1)",
    secondaryColor: "rgba(232, 102, 105, 0.1)",
    onClickFunctionName: "logout"
  }
];

function LightHomeIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.1831 0.712325L14.6308 4.00005C15.484 4.62022 15.9918 5.609 15.9986 6.66382V12.6153C15.9506 14.5298 14.3615 16.0438 12.4469 15.999H3.5517C1.63718 16.0438 0.0480156 14.5298 0 12.6153V6.67182C0.00488227 5.61243 0.51631 4.6193 1.37588 4.00005L5.81551 0.712325C7.11649 -0.237442 8.88216 -0.237442 10.1831 0.712325ZM12.447 14.7993C13.699 14.8443 14.7511 13.8674 14.7988 12.6155V6.66399C14.7947 5.98833 14.4638 5.35644 13.9109 4.96813L9.47125 1.68041C8.59445 1.04012 7.4043 1.04012 6.5275 1.68041L2.08788 4.96013C1.53446 5.3553 1.20422 5.99198 1.19995 6.67199V12.6155C1.25197 13.8654 2.30144 14.8399 3.55175 14.7993H12.447Z"
        fill="black"
      />
      <path
        d="M11.5996 10.9995H4.39956C4.06819 10.9995 3.79956 11.2681 3.79956 11.5995C3.79956 11.9309 4.06819 12.1995 4.39956 12.1995H11.5996C11.9309 12.1995 12.1996 11.9309 12.1996 11.5995C12.1996 11.2681 11.9309 10.9995 11.5996 10.9995Z"
        fill="black"
      />
    </svg>
  );
}

function SolidHomeIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 4.5L8 0.5L6.5 1L4.5 2.5L2 4.5L1 6L0.5 11.5L1 13.5L2 15L5 15.5H10.5L14.5 15L15 13.5L15.5 11L15 5.5L14.5 4.5Z"
        fill="#22548A"
      />
      <path
        d="M11.5996 10.9995H4.39956C4.06819 10.9995 3.79956 11.2681 3.79956 11.5995C3.79956 11.9309 4.06819 12.1995 4.39956 12.1995H11.5996C11.9309 12.1995 12.1996 11.9309 12.1996 11.5995C12.1996 11.2681 11.9309 10.9995 11.5996 10.9995Z"
        fill="white"
      />
    </svg>
  );
}

function LightAppointmentIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 19L7.5 7.5L19 11.3L14 13.5L11.5 19Z"
        stroke="#040404"
        stroke-linejoin="round"
      />
      <path
        d="M3.93796 2.9612C3.67371 2.72485 3.27405 2.72485 3.0098 2.9612C2.78156 3.22849 2.78156 3.62206 3.0098 3.88936L4.86612 5.8385C4.9987 5.96582 5.17427 6.03869 5.35804 6.04269C5.5422 6.04055 5.71843 5.9674 5.84997 5.8385C5.9983 5.71223 6.08604 5.52893 6.09135 5.33421C6.09666 5.13949 6.01904 4.95168 5.87781 4.81752L3.93796 2.9612Z"
        fill="#131313"
      />
      <path
        d="M7.90128 4.81756C8.08592 4.8127 8.26107 4.73466 8.38815 4.60062C8.51523 4.46657 8.58383 4.28752 8.57884 4.10288V1.40193C8.57884 1.01747 8.26717 0.705811 7.88272 0.705811C7.49826 0.705811 7.1866 1.01747 7.1866 1.40193V4.10288C7.18143 4.29396 7.25506 4.47876 7.39023 4.61393C7.5254 4.74909 7.7102 4.82273 7.90128 4.81756Z"
        fill="#131313"
      />
      <path
        d="M10.4909 4.76182C10.6757 4.76269 10.853 4.68909 10.9828 4.55763L12.8949 2.64561C13.0811 2.47208 13.1578 2.21072 13.0948 1.96408C13.0318 1.71743 12.8392 1.52484 12.5925 1.46185C12.3459 1.39886 12.0845 1.47553 11.911 1.66176L9.99899 3.57378C9.72755 3.84556 9.72755 4.28584 9.99899 4.55763C10.1288 4.68909 10.3062 4.76269 10.4909 4.76182Z"
        fill="#131313"
      />
      <path
        d="M3.62237 9.95034L1.71036 11.8623C1.43891 12.1341 1.43891 12.5744 1.71036 12.8462C1.83958 12.9786 2.01731 13.0523 2.20228 13.0504C2.38705 13.0513 2.56437 12.9777 2.69421 12.8462L4.60622 10.9342C4.79246 10.7606 4.86912 10.4993 4.80613 10.2527C4.74314 10.006 4.55055 9.81341 4.30391 9.75043C4.05726 9.68744 3.79591 9.7641 3.62237 9.95034Z"
        fill="#131313"
      />
      <path
        d="M4.11436 7.1936H1.40413C1.01967 7.1936 0.708008 7.50527 0.708008 7.88972C0.708008 8.27418 1.01967 8.58584 1.40413 8.58584H4.11436C4.49881 8.58584 4.81048 8.27418 4.81048 7.88972C4.81048 7.50527 4.49881 7.1936 4.11436 7.1936Z"
        fill="#131313"
      />
    </svg>
  );
}

function SolidAppointmentIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 19L7.5 7.5L19 11.3L14 13.5L11.5 19Z"
        fill="#22548A"
        stroke="#22548A"
        stroke-linejoin="round"
      />
      <path
        d="M3.93796 2.9612C3.67371 2.72485 3.27405 2.72485 3.0098 2.9612C2.78156 3.22849 2.78156 3.62206 3.0098 3.88936L4.86612 5.8385C4.9987 5.96582 5.17427 6.03869 5.35804 6.04269C5.5422 6.04055 5.71843 5.9674 5.84997 5.8385C5.9983 5.71223 6.08604 5.52893 6.09135 5.33421C6.09666 5.13949 6.01904 4.95168 5.87781 4.81752L3.93796 2.9612Z"
        fill="#22548A"
      />
      <path
        d="M7.90122 4.81756C8.08586 4.8127 8.26101 4.73466 8.38809 4.60062C8.51517 4.46657 8.58377 4.28752 8.57878 4.10288V1.40193C8.57878 1.01747 8.26711 0.705811 7.88265 0.705811C7.4982 0.705811 7.18653 1.01747 7.18653 1.40193V4.10288C7.18137 4.29396 7.255 4.47876 7.39017 4.61393C7.52533 4.74909 7.71013 4.82273 7.90122 4.81756Z"
        fill="#22548A"
      />
      <path
        d="M10.4909 4.76182C10.6757 4.76269 10.853 4.68909 10.9828 4.55763L12.8949 2.64561C13.0811 2.47208 13.1578 2.21072 13.0948 1.96408C13.0318 1.71743 12.8392 1.52484 12.5925 1.46185C12.3459 1.39886 12.0845 1.47553 11.911 1.66176L9.99899 3.57378C9.72755 3.84556 9.72755 4.28584 9.99899 4.55763C10.1288 4.68909 10.3062 4.76269 10.4909 4.76182Z"
        fill="#22548A"
      />
      <path
        d="M3.62243 9.95034L1.71042 11.8623C1.43898 12.1341 1.43898 12.5744 1.71042 12.8462C1.83964 12.9786 2.01737 13.0523 2.20234 13.0504C2.38711 13.0513 2.56443 12.9777 2.69427 12.8462L4.60628 10.9342C4.79252 10.7606 4.86918 10.4993 4.80619 10.2527C4.7432 10.006 4.55061 9.81341 4.30397 9.75043C4.05732 9.68744 3.79597 9.7641 3.62243 9.95034Z"
        fill="#22548A"
      />
      <path
        d="M4.11436 7.1936H1.40413C1.01967 7.1936 0.708008 7.50527 0.708008 7.88972C0.708008 8.27418 1.01967 8.58584 1.40413 8.58584H4.11436C4.49881 8.58584 4.81048 8.27418 4.81048 7.88972C4.81048 7.50527 4.49881 7.1936 4.11436 7.1936Z"
        fill="#22548A"
      />
    </svg>
  );
}

function LightPCIIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 13.6063L13.4562 15.9488C13.4768 15.9596 13.5 15.9644 13.5232 15.9627C13.5464 15.961 13.5687 15.9529 13.5875 15.9393C13.6063 15.9256 13.621 15.907 13.6298 15.8855C13.6386 15.864 13.6413 15.8405 13.6375 15.8175L12.7875 10.855L16.3912 7.34127C16.4077 7.325 16.4194 7.30447 16.4249 7.28196C16.4304 7.25946 16.4295 7.23587 16.4224 7.21383C16.4152 7.19179 16.4021 7.17217 16.3845 7.15715C16.3668 7.14213 16.3454 7.1323 16.3225 7.12877L11.34 6.40377L9.1125 1.88877C9.10227 1.86764 9.08629 1.84981 9.06639 1.83734C9.04649 1.82487 9.02349 1.81826 9 1.81826C8.97652 1.81826 8.95351 1.82487 8.93362 1.83734C8.91372 1.84981 8.89774 1.86764 8.8875 1.88877L6.66001 6.40377L1.67751 7.12877C1.65462 7.1323 1.63316 7.14213 1.61552 7.15715C1.59789 7.17217 1.58477 7.19179 1.57764 7.21383C1.57051 7.23587 1.56965 7.25946 1.57514 7.28196C1.58064 7.30447 1.59228 7.325 1.60876 7.34127L5.21251 10.855L4.36126 15.8175C4.35745 15.8405 4.36011 15.864 4.36894 15.8855C4.37777 15.907 4.39243 15.9256 4.41125 15.9393C4.43008 15.9529 4.45234 15.961 4.47553 15.9627C4.49871 15.9644 4.52191 15.9596 4.54251 15.9488L9 13.6063ZM5.12501 17.0563C4.89787 17.1757 4.64185 17.2292 4.38591 17.2107C4.12996 17.1921 3.8843 17.1024 3.67673 16.9515C3.46915 16.8006 3.30793 16.5947 3.21131 16.3569C3.1147 16.1192 3.08653 15.8592 3.13001 15.6063L3.87001 11.2913L0.737513 8.23752C0.553877 8.05839 0.424015 7.83146 0.362607 7.58239C0.301199 7.33331 0.310695 7.07203 0.390021 6.82807C0.469348 6.58411 0.61534 6.3672 0.811495 6.20187C1.00765 6.03655 1.24614 5.92939 1.50001 5.89252L5.83126 5.26252L7.76875 1.33752C7.88241 1.10772 8.05804 0.914268 8.27583 0.779012C8.49362 0.643757 8.74488 0.572083 9.00125 0.572083C9.25762 0.572083 9.50889 0.643757 9.72667 0.779012C9.94446 0.914268 10.1201 1.10772 10.2338 1.33752L12.1712 5.26252L16.5037 5.89252C16.7576 5.92939 16.9961 6.03655 17.1923 6.20187C17.3884 6.3672 17.5344 6.58411 17.6137 6.82807C17.6931 7.07203 17.7026 7.33331 17.6411 7.58239C17.5797 7.83146 17.4499 8.05839 17.2662 8.23752L14.1312 11.2925L14.8712 15.6075C14.9147 15.8604 14.8866 16.1205 14.7899 16.3582C14.6933 16.5959 14.5321 16.8019 14.3245 16.9527C14.117 17.1036 13.8713 17.1934 13.6153 17.2119C13.3594 17.2304 13.1034 17.177 12.8762 17.0575L9 15.0175L5.12501 17.055V17.0563Z"
        fill="#333333"
      />
    </svg>
  );
}

function SolidPCIIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 5L7.5 0.5L8.5 0L10.5 5L16 5.5V6.5L12.5 10.5L13 15.5L8 13.5L3 15.5L3.5 10L1.5 8L0 5.5L5 5Z"
        fill="#22548A"
      />
    </svg>
  );
}

function LightReviewIcon() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="9" width="4.53237" height="8" rx="1" stroke="black" />
      <rect
        x="14.4675"
        y="6"
        width="4.53237"
        height="11"
        rx="1"
        stroke="black"
      />
      <rect
        x="7.73389"
        y="1"
        width="4.53237"
        height="16"
        rx="1"
        stroke="black"
      />
    </svg>
  );
}

function SolidReviewIcon() {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="8" width="4.53237" height="8" rx="1" fill="#22548A" />
      <rect
        x="13.4675"
        y="5"
        width="4.53237"
        height="11"
        rx="1"
        fill="#22548A"
      />
      <rect x="6.73389" width="4.53237" height="16" rx="1" fill="#22548A" />
    </svg>
  );
}

function CheckoutIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 12V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H8M11.5 8.5L19 1L11.5 8.5ZM14 1H19V6L14 1Z"
        stroke="#22548A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function LogoutIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.325 13.275C12.1417 13.0583 12.05 12.8123 12.05 12.537C12.05 12.2623 12.1417 12.0333 12.325 11.85L14.175 10H7C6.71667 10 6.47933 9.904 6.288 9.712C6.096 9.52067 6 9.28333 6 9C6 8.71667 6.096 8.479 6.288 8.287C6.47933 8.09567 6.71667 8 7 8H14.175L12.325 6.15C12.125 5.95 12.025 5.71267 12.025 5.438C12.025 5.16267 12.125 4.925 12.325 4.725C12.5083 4.525 12.7377 4.425 13.013 4.425C13.2877 4.425 13.5167 4.51667 13.7 4.7L17.3 8.3C17.4 8.4 17.471 8.50833 17.513 8.625C17.5543 8.74167 17.575 8.86667 17.575 9C17.575 9.13333 17.5543 9.25833 17.513 9.375C17.471 9.49167 17.4 9.6 17.3 9.7L13.7 13.3C13.4833 13.5167 13.246 13.6123 12.988 13.587C12.7293 13.5623 12.5083 13.4583 12.325 13.275ZM2 18C1.45 18 0.979 17.8043 0.587 17.413C0.195667 17.021 0 16.55 0 16V2C0 1.45 0.195667 0.979 0.587 0.587C0.979 0.195667 1.45 0 2 0H8C8.28333 0 8.521 0.0956666 8.713 0.287C8.90433 0.479 9 0.716667 9 1C9 1.28333 8.90433 1.52067 8.713 1.712C8.521 1.904 8.28333 2 8 2H2V16H8C8.28333 16 8.521 16.096 8.713 16.288C8.90433 16.4793 9 16.7167 9 17C9 17.2833 8.90433 17.5207 8.713 17.712C8.521 17.904 8.28333 18 8 18H2Z"
        fill="#E86669"
      />
    </svg>
  );
}

function LightAuditLogsIcon() {
  return (
    <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 8H4C3.4375 8 3 8.46875 3 9V16.75C3 16.9062 3.09375 17 3.25 17H3.75C3.875 17 4 16.9062 4 16.75V15H16V16.75C16 16.9062 16.0938 17 16.25 17H16.75C16.875 17 17 16.9062 17 16.75V9C17 8.46875 16.5312 8 16 8ZM16 14H4V12H16V14ZM16 11H4V9H16V11ZM19.0625 4.71875L10.5625 1.125C10.1875 0.96875 9.78125 0.96875 9.40625 1.125L0.90625 4.71875C0.34375 4.9375 0 5.5 0 6.09375V16.75C0 16.9062 0.09375 17 0.25 17H0.75C0.875 17 1 16.9062 1 16.75V6.09375C1 5.875 1.09375 5.71875 1.28125 5.625L9.78125 2.0625C9.90625 2 10.0625 2 10.1875 2.0625L18.6875 5.625C18.875 5.71875 19 5.875 19 6.09375V16.75C19 16.9062 19.0938 17 19.25 17H19.75C19.875 17 20 16.9062 20 16.75V6.09375C20 5.5 19.625 4.9375 19.0625 4.71875Z" fill="#909090" />
    </svg>
  )
}

function SolidAuditLogsIcon() {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.75 11H4.25C4.125 11 4 11.125 4 11.25V12.75C4 12.9062 4.09375 13 4.25 13H15.75C15.875 13 16 12.9062 16 12.75V11.25C16 11.125 15.875 11 15.75 11ZM15.75 14H4.25C4.09375 14 4 14.125 4 14.25V15.75C4 15.9062 4.09375 16 4.25 16H15.75C15.875 16 16 15.9062 16 15.75V14.25C16 14.125 15.875 14 15.75 14ZM15.75 8H4.25C4.125 8 4 8.125 4 8.25V9.75C4 9.90625 4.125 10 4.25 10H15.75C15.875 10 16 9.90625 16 9.75V8.25C16 8.125 15.875 8 15.75 8ZM19.0625 3.65625L10.5625 0.125C10.375 0.0625 10.1875 0.03125 9.96875 0.03125C9.78125 0.03125 9.59375 0.0625 9.40625 0.125L0.90625 3.65625C0.34375 3.90625 0 4.4375 0 5.0625V15.75C0 15.9062 0.09375 16 0.25 16H2.75C2.875 16 3 15.9062 3 15.75V8C3 7.46875 3.4375 7 4 7H15.9688C16.5312 7 17 7.46875 17 8V15.75C17 15.9062 17.0938 16 17.25 16H19.75C19.875 16 20 15.9062 20 15.75V5.0625C20 4.4375 19.625 3.90625 19.0625 3.65625Z" fill="#22548A" />
    </svg>

  )
}